import { render } from "./PerfilUsuario.vue?vue&type=template&id=4cff4400&scoped=true"
import script from "./PerfilUsuario.vue?vue&type=script&lang=js"
export * from "./PerfilUsuario.vue?vue&type=script&lang=js"

import "./PerfilUsuario.vue?vue&type=style&index=0&id=4cff4400&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cff4400"]])

export default __exports__